// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {useHistory} from 'react-router';
import {Flag} from '../common/flag';
import country from '/util/country.js';
import {bd_countries} from 'hola_opt';
import styles from './top_locations.module.less';

interface i_top_props {
    mode: string;
    continent_name?: string;
}

const landing_countries = [
  {country: 'us', title: 'United States'},
  {country: 'gb', title: 'United Kingdom'},
  {country: 'sg', title: 'Singapore'},
  {country: 'ph', title: 'Philippines'},
  {country: 'ru', title: 'Russia'},
  {country: 'cn', title: 'China'},
  {country: 'tr', title: 'Turkey'},
  {country: 'de', title: 'Germany'},
  {country: 'br', title: 'Brazil'},
  {country: 'eg', title: 'Egypt'},
  {country: 'in', title: 'India'},
  {country: 'nl', title: 'Netherlands'},
];

const get_continent_key = continent_name=>{
    const continent_mapping = {
        'europe': 'Europe',
        'north-america': 'Northern America',
        'latin-america': 'LATAM',
        'asia': 'Asia',
        'africa': 'Africa',
        'oceania': 'Oceania'
    };
    return continent_mapping[continent_name.toLowerCase()] ||
        continent_name.replace(/\b\w/g, c=>c.toUpperCase());
};

const get_region_countries = region=>{
    const excluded_ountries = ['ps'];
    const countries = bd_countries.by_region[region]?.countries || [];
    return countries.filter(ctr=>!excluded_ountries.includes(ctr));
};

const normalize_continent_name = name=>{
    return name.split('-').map(word=>
      word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
};

export const Top_locations = (props: i_top_props)=>{
    const {mode, continent_name} = props;
    const history = useHistory();
    const title = mode == 'landing' ? 'Top Proxy Locations' :
        `${normalize_continent_name(continent_name || '')} Proxy Locations`;
    const countries = mode == 'landing' ? landing_countries :
        get_region_countries(get_continent_key(continent_name || ''));
    const get_country_url = _title=>{
        let country_param = _title.toLowerCase().replace(' ', '-');
        if (_title == 'United Kingdom')
            country_param = 'great-britain';
        history.push(`/proxy-location/${country_param}`);
        window.scrollTo({top: 0, behavior: 'smooth'});
    };
    return <div className={styles.top_locations}>
      <div className={styles.locations_text}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.flags}>
          {countries.map(c=>{
              const country_code = typeof c == 'string' ? c : c.country;
              const country_name = typeof c == 'string' ?
                country.list[country_code.toUpperCase()] : c.title;
              return <div
                key={country_code}
                className={styles.country_ip}
                onClick={e=>{
                  e.preventDefault();
                  get_country_url(country_name); }}>
                  <div className={styles.line_with_flag}>
                    <Flag country={country_code} size={30}/>
                    <p className={cn(styles.country_name)}>
                      {country_name}
                    </p>
                  </div>
              </div>;
          })}
        </div>
      </div>
  </div>;
};
